'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _Solutions = require('./Solutions.css');

var _Solutions2 = _interopRequireDefault(_Solutions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Solutions = (_dec = (0, _reactCssModules2.default)(_Solutions2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Solutions, _Component);

  function Solutions(props) {
    (0, _classCallCheck3.default)(this, Solutions);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Solutions.__proto__ || (0, _getPrototypeOf2.default)(Solutions)).call(this, props));

    _this.state = {
      title: 'The solutions',
      description: 'Retirement plans should offer sustainable investing options to all plan participants. Making the default investment option sustainable is the best way to protect people from the financial risks of unsustainable investments.',
      url: _config2.default.domain + _config2.default.routes.solutions
    };
    return _this;
  }

  (0, _createClass3.default)(Solutions, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'h1',
            { styleName: 'large-page-title' },
            this.state.title
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content' },
            _react2.default.createElement(
              'p',
              null,
              'Employees who put away a portion of their hard-earned paycheck for retirement need sustainable investing options. It is the responsibility of every company to ensure that the retirement plan offers sustainable investments. The problem is that the default option, which is rarely sustainable, is the simplest to join so most people opt-in without fully understanding that this means that their money is being invested into risk sectors like fossil fuels, deforestation, prisons, and weapons.'
            ),
            _react2.default.createElement(_components.SolutionsList, null)
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null)
      );
    }
  }]);
  return Solutions;
}(_react.Component)) || _class);
exports.default = Solutions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Solutions/Solutions.js
// module id = 1500
// module chunks = 0